import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, MessageCircle, ClipboardList } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { useOrder, orderMessage } from "@/context/OrderContext";
import { waLink } from "@/lib/site";
import { useLang } from "@/context/LangContext";

const Row = ({ item }) => {
  const { setQty } = useOrder();
  const { t } = useLang();
  return (
    <li data-testid={`order-item-${item.id}`} className="flex items-center gap-3 border-b border-leaf/10 py-3">
      <img src={item.img} alt={item.name} className="h-14 w-14 rounded-t-full rounded-b-md bg-[var(--mint)] object-contain" />
      <div className="min-w-0 flex-1">
        <p className="truncate font-display text-sm font-bold">{item.name}</p>
        <p className="text-xs text-[var(--muted-ink)]">{item.price || t("Tanya harga", "Ask for price")}</p>
      </div>
      <div className="flex items-center gap-1">
        <button data-testid={`order-item-dec-${item.id}`} onClick={() => setQty(item.id, item.qty - 1)} className="grid h-7 w-7 place-items-center rounded-full border hover:bg-[var(--mint)]" aria-label="Kurangi">
          {item.qty === 1 ? <Trash2 className="h-3.5 w-3.5" /> : <Minus className="h-3.5 w-3.5" />}
        </button>
        <span className="w-6 text-center text-sm font-semibold">{item.qty}</span>
        <button data-testid={`order-item-inc-${item.id}`} onClick={() => setQty(item.id, item.qty + 1)} className="grid h-7 w-7 place-items-center rounded-full border hover:bg-[var(--mint)]" aria-label="Tambah">
          <Plus className="h-3.5 w-3.5" />
        </button>
      </div>
    </li>
  );
};

export const OrderDrawer = () => {
  const { items, open, setOpen } = useOrder();
  const nav = useNavigate();
  const { t } = useLang();
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="order-drawer" className="flex w-full flex-col bg-[var(--paper)] sm:max-w-md" data-lenis-prevent>
        <SheetHeader>
          <SheetTitle className="font-display text-2xl font-black text-[var(--leaf-deep)]">{t("Daftar Pesanan", "Order List")}</SheetTitle>
          <SheetDescription>{t("Kirim langsung via WhatsApp atau lanjutkan ke formulir pemesanan.", "Send it straight to WhatsApp or continue to the order form.")}</SheetDescription>
        </SheetHeader>
        <ul className="mt-4 flex-1 overflow-y-auto">
          {items.length === 0 && <p data-testid="order-drawer-empty" className="py-10 text-center text-sm text-[var(--muted-ink)]">{t("Belum ada tanaman dipilih. Jelajahi katalog lalu tekan \"+ Pesanan\".", "No plants selected yet. Browse the catalogue and tap \"+ Order\".")}</p>}
          {items.map((i) => <Row key={i.id} item={i} />)}
        </ul>
        <div className="grid gap-2 pt-4">
          <a data-testid="order-drawer-whatsapp-btn" href={waLink(orderMessage(items))} target="_blank" rel="noreferrer"
            className={`inline-flex items-center justify-center gap-2 rounded-full bg-[var(--leaf)] px-5 py-3 font-display text-sm font-bold text-white ${items.length ? "" : "pointer-events-none opacity-40"}`}>
            <MessageCircle className="h-4 w-4" /> {t("Kirim via WhatsApp", "Send via WhatsApp")}
          </a>
          <button data-testid="order-drawer-form-btn" onClick={() => { setOpen(false); nav("/kontak#form"); }}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-[var(--leaf)] px-5 py-3 font-display text-sm font-bold text-[var(--leaf)] hover:bg-[var(--mint)]">
            <ClipboardList className="h-4 w-4" /> {t("Isi Formulir Pemesanan", "Fill in the Order Form")}
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};
